import { render } from "./Quotations2.vue?vue&type=template&id=6e02a911"
import script from "./Quotations2.vue?vue&type=script&lang=js"
export * from "./Quotations2.vue?vue&type=script&lang=js"
script.render = render

export default script